export default __webpack_public_path__ + "static/media/en_img.8f755733.png";